import { axios } from "@/client/libs/axios";

export type SubscriptionStatus = {
  hasSubscription: boolean;
  productType: string | null;
};

export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  try {
    const response = await axios.get<{ product_type: string | null; has_subscription: boolean }>(
      "/subscription/status",
    );
    return {
      hasSubscription: response.data.has_subscription,
      productType: response.data.product_type ?? null,
    };
  } catch {
    return { hasSubscription: false, productType: null };
  }
};
